// Subscription Layout Updater (Grid)
document.addEventListener('change', function(e) {
  const container = e.target.closest('.kh-subs-container');
  if (!container) return;

  const formId = container.getAttribute('data-form-id');
  const hiddenInput = document.getElementById(`selling_plan_${formId}`);
  const subRadio = container.querySelector('.kh-sub-radio');
  
  const activePlan = container.querySelector('.kh-plan-input:checked') || container.querySelector('.kh-plan-input');
  const subscriptionPrice = container.querySelector('[data-subscription-price]');
  if (subscriptionPrice && activePlan) subscriptionPrice.textContent = activePlan.dataset.price;

  let newPrice = null;

  if (e.target.classList.contains('kh-onetime-radio')) {
    hiddenInput.value = ''; 
    newPrice = e.target.getAttribute('data-price');
  } 
  else if (e.target.classList.contains('kh-sub-radio')) {
    const activePlan = container.querySelector('.kh-plan-input:checked') || container.querySelector('.kh-plan-input');
    if (activePlan) {
        activePlan.checked = true;
        hiddenInput.value = activePlan.value;
        newPrice = activePlan.getAttribute('data-price');
    }
  }
  else if (e.target.classList.contains('kh-plan-input')) {
    subRadio.checked = true; 
    hiddenInput.value = e.target.value; 
    newPrice = e.target.getAttribute('data-price');
  }

  if (newPrice) {
    // Expand scope to safely catch PDP or Quickview containers
    const scope = container.closest('.product-quick-view__content, .product__info-wrapper, .product') || document;
    
    // Updated Regex to safely handle comma-formatted numbers like $1,195.00
    const priceRegex = /[\$\£\€]\d{1,3}(?:[,\.]\d{3})*(?:[\.\,]\d{2})?/g;

    const priceDisplays = scope.querySelectorAll('.product__price, .price-per-item--current');
    priceDisplays.forEach(el => {
      el.innerHTML = el.innerHTML.replace(priceRegex, newPrice);
    });

    const atcButton = document.getElementById(`${formId}-submit`) || scope.querySelector('[name="add"]');
    if (atcButton) {
      atcButton.innerHTML = atcButton.innerHTML.replace(priceRegex, newPrice);
    }
  }
});